module.exports = __webpack_public_path__ + "static/Terminal-00a14d1d74cb6497453df6cde63458db.png";